import { create } from 'zustand';
import {
  bundleToUI,
  projectToUI,
  type WorkspaceBundleUI,
  type WorkspaceProjectUI,
} from '@flexiplanner/types';
import { api } from '@/lib/api';

interface WorkspaceState {
  projects: WorkspaceProjectUI[];
  bundles: WorkspaceBundleUI[];
  defaultBundleId: string | null;
  isLoaded: boolean;
  setWorkspace: (data: any) => void;
  loadWorkspace: () => Promise<void>;
  getBundle: (id?: string | null) => WorkspaceBundleUI | undefined;
  getProject: (id?: string | null) => WorkspaceProjectUI | undefined;
}

export const useWorkspaceStore = create<WorkspaceState>((set, get) => ({
  projects: [],
  bundles: [],
  defaultBundleId: null,
  isLoaded: false,

  setWorkspace: data => {
    const projects = (data?.projects || []).map(projectToUI);
    const bundles = (data?.bundles || []).map(bundleToUI);
    set({
      projects,
      bundles,
      defaultBundleId: data?.default_bundle_id || null,
      isLoaded: true,
    });
  },

  loadWorkspace: async () => {
    const response = await api.workspace.get();
    if (response.success && response.data) {
      get().setWorkspace(response.data);
    }
  },

  getBundle: id => get().bundles.find(bundle => bundle.id === id),
  getProject: id => get().projects.find(project => project.id === id),
}));
